import { v4 as uuidv4 } from 'uuid';
import DateField from '../DateField';
import GetDateValueDialog from '../GetDateValueDialog';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PropTypes from 'prop-types';
import { Component } from 'react';
import CommonIriDisplay from '../../application-core/CommonIriDisplay';
import ComponentSelector from '../../application-core/ComponentSelector';
import GS from '../../grafsync/grafsync';
import EntitlementWarning from '../EntitlementWarning';
import Errored from '../Errored';
import Notification from '../Notification';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import ProjectUsers from '../ProjectUsers';
import QueryParameterDisplay from '../sparql/QueryParameterDisplay';
import { globalStyles as styles } from '../style/gstheme';
import { DATATYPE_LIMITS, ENTITLEMENTS, MAX_LITERAL_LENGTH, NS_ACL } from '../utils/constants';
import { checkValidity, computeLabelFromType, makeCancelable, sanitiseText } from '../utils/utils';
import withGS from '../withGShoc';
import ReportSearch from './ReportSearch';

const componentTypes = [
  "http://www.w3.org/2004/02/skos/core#ConceptScheme",
  "http://www.w3.org/2004/02/skos/core#Collection",
  "http://www.w3.org/2004/02/skos/core#OrderedCollection",
  "http://www.w3.org/2002/07/owl#Ontology",
  "https://grafsync.graphifi.com/schema/gs/Dataset"

];
const resourceTypes = [
  "http://www.w3.org/2004/02/skos/core#Concept",
  "http://www.w3.org/2008/05/skos-xl#Label",
  "http://www.w3.org/2002/07/owl#Class",
  "http://www.w3.org/2002/07/owl#ObjectProperty",
  "http://www.w3.org/2002/07/owl#DatatypeProperty",
  "http://www.w3.org/2002/07/owl#AnnotationProperty",
  "http://www.w3.org/2002/07/owl#NamedIndividual",
  "https://grafsync.graphifi.com/schema/gs/Resource"
];
const literalTypes = [
  "http://www.w3.org/2001/XMLSchema#date",
  "http://www.w3.org/2001/XMLSchema#integer",
  "http://www.w3.org/2001/XMLSchema#decimal",
  "http://www.w3.org/2001/XMLSchema#string"
];

const resourceTypesInComponent = {
  "http://www.w3.org/2004/02/skos/core#Concept": "http://www.w3.org/2004/02/skos/core#inScheme",
  "http://www.w3.org/2008/05/skos-xl#Label": "http://www.w3.org/2004/02/skos/core#inScheme",
  "http://www.w3.org/2002/07/owl#Class": [
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility"
  ],
  "http://www.w3.org/2002/07/owl#ObjectProperty": [
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility"
  ],
  "http://www.w3.org/2002/07/owl#DatatypeProperty": [
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility"
  ],
  "http://www.w3.org/2002/07/owl#AnnotationProperty": [
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility"
  ],
  "http://www.w3.org/2002/07/owl#NamedIndividual": [
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility"
  ],
  "https://grafsync.graphifi.com/schema/gs/Resource": [
    "https://grafsync.graphifi.com/schema/gs/inDataset"
  ]
};
const resourceTypesLabel = {
  "http://www.w3.org/2004/02/skos/core#Concept": "http://www.w3.org/2004/02/skos/core#prefLabel",
  "http://www.w3.org/2008/05/skos-xl#Label": "http://www.w3.org/2008/05/skos-xl#literalForm",
  "http://www.w3.org/2002/07/owl#Class": "http://www.w3.org/2000/01/rdf-schema#label",
  "http://www.w3.org/2002/07/owl#ObjectProperty": "http://www.w3.org/2000/01/rdf-schema#label",
  "http://www.w3.org/2002/07/owl#DatatypeProperty": "http://www.w3.org/2000/01/rdf-schema#label",
  "http://www.w3.org/2002/07/owl#AnnotationProperty": "http://www.w3.org/2000/01/rdf-schema#label",
  "http://www.w3.org/2002/07/owl#NamedIndividual": "http://www.w3.org/2000/01/rdf-schema#label",
  "https://grafsync.graphifi.com/schema/gs/Resource": "http://www.w3.org/2000/01/rdf-schema#label"
};
const resourceTypesProperty = {
  "http://www.w3.org/2004/02/skos/core#Concept": "prefLabel",
  "http://www.w3.org/2008/05/skos-xl#Label": "literalForm",
  "http://www.w3.org/2002/07/owl#Class": "label",
  "http://www.w3.org/2002/07/owl#ObjectProperty": "label",
  "http://www.w3.org/2002/07/owl#DatatypeProperty": "label",
  "http://www.w3.org/2002/07/owl#AnnotationProperty": "label",
  "http://www.w3.org/2002/07/owl#NamedIndividual": "label",
  "https://grafsync.graphifi.com/schema/gs/Resource": "label"
};

class ReportParameters extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      keyUuid: uuidv4(),
      filters: [],
      literal: "",
      literalError: {},
      queryParameter: props.queryParameter,
      values: {},
      parametersLoading: true
    };
    this.cancellable = null;
  }

  componentDidMount = () => this.getSavedQueryParameters();

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.queryParameter && props.data.queryParameter.length !== state.queryParameter) {
      return {
        ...(props.data.queryParameter && props.data.queryParameter.length !== state.queryParameter) && {
          isLoading: true,
          queryParameter: props.data.queryParameter.length
        }
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (!this.state.isErrored && this.state.isLoading === true) {
      this.getSavedQueryParameters();
    }
  }

  getSavedQueryParameters = async () => {
    try {
      GS.handle("report-get-saved-parameters");
      await this.doGetParameters().promise;
      const queryParameter = this.props.data.queryParameter;
      let existingVariables = [];
      const filters = queryParameter ?
        queryParameter.map(qp => {
          const data = GS.data(qp, this.props.graph, false);
          if (data) {
            existingVariables.push(data.queryVariable);
            return {
              id: qp,
              variable: data.queryVariable,
              description: data.description ? data.description[this.props.defaultLang] : "",
              type: data.queryReplacementType,
              constraint: data.queryConstraint,
              optional: data.optional === true
            };
          }
          return {};
        })
        :
        [];
      existingVariables.sort();
      const sortedFilters = existingVariables.map(ev => filters.find(f => f.variable === ev));
      this.setState({ filters: sortedFilters, isLoading: false, values: {}, keyUuid: uuidv4() });
    }
    catch (e) {
      if (this.cancellable && this.cancellable.isCancelled()) return;
      this.setState({ isErrored: e, errorMessage: "Could not get saved query parameters.", isLoading: false });
    }
  };

  doGetParameters() {
    this.cancellable = makeCancelable(GS.loadData(this.props.data.queryParameter, {}, this.props.graph, false));
    return this.cancellable;
  }

  handleValueSetting = (parameter) => (iri) => {
    let values = Object.assign({}, this.state.values);
    values[parameter] = iri;
    this.setState({ values });
    this.props.onClear();
  };

  removeValueSetting = (parameter) => () => {
    let values = Object.assign({}, this.state.values);
    delete values[parameter];
    this.setState({ values });
    this.props.onClear();
  };

  resetQuery = () => {
    this.setState({ values: {}, keyUuid: uuidv4() });
    this.props.onClear();
  };

  playQuery = () => this.props.runQuery(this.props.playQuery, this.state.values);

  handleLiteralChange = (datatype, parameter) => (event) => {
    const t = event.target;
    const cleanText = sanitiseText(t.value.toString().trimLeft());
    let values = Object.assign({}, this.state.values);
    values[parameter] = cleanText;
    const validity = cleanText === "" ? false : checkValidity(cleanText, datatype, []);
    const newLiteralError = Object.assign({}, this.state.literalError);
    newLiteralError[parameter] = !validity.isValid;
    this.setState({ values, literalError: newLiteralError });
  };

  handleDataChange = (parameter) => (date) => {
    let values = Object.assign({}, this.state.values);
    values[parameter] = date;
    this.setState({ values });
  };

  monitorLinkUpdate = (iri, property) => {
    if (property === "optional") this.getSavedQueryParameters();
  };

  render() {

    const { classes, project, graph, existingComponents, defaultLang, entitlements,
      queryRunning, disabled, projectUsers, data, margin, query } = this.props;
    if (!("queryParameter" in data) || data.queryParameter.length === 0) return null;

    const { isErrored, errorMessage, filters, values, literalError, keyUuid } = this.state;
    const canRunSavedQueries = entitlements && entitlements.includes(ENTITLEMENTS.CAN_RUN_SAVED_QUERY);
    const invalidLiterals = Object.values(literalError).includes(true);

    const queryChanged = query && query !== data.query;
    if (queryChanged) {
      return <div style={{ marginTop: 4 }}>
        <Notification dataTest="disabled-parameters" error={false} text="Parameters disabled due to the query being updated." />
      </div>;
    }

    const headers = [
      ...filters.filter(p => componentTypes.includes(p.type)),
      ...filters.filter(p => resourceTypes.includes(p.type)),
      ...filters.filter(p => literalTypes.includes(p.type)),
      ...filters.filter(p => p.type === NS_ACL + "User")
    ];

    const gridWidth = filters.length > 0 ? Math.floor(10 / filters.length) : 2;

    if (!canRunSavedQueries) {
      return <div style={{ marginTop: 12, marginBottom: 12 }}>
        <EntitlementWarning
          border={true}
          needAll={true}
          message={margin ?
            "You do not have permissions to run as a saved query with parameters."
            :
            "You do not have permissions to run a parameterised report."
          }
          requiredEntitlements={[
            ENTITLEMENTS.CAN_RUN_SAVED_QUERY
          ]} />
      </div>;
    }

    const incomplete = filters.some(p => !p.optional && !values[p.variable]);

    return (
      <div
        data-test="parameter-entry"
        id="parameter-entry"
        style={{
          ...(margin) && {
            marginTop: 36
          }
        }}>
        {margin &&
          <Typography variant="body2">To run the saved query with parameters set values in the area below.</Typography>
        }
        <div style={{
          minHeight: 100,
          marginBottom: 24,
          ...(margin) && {
            marginTop: 24,
            borderRadius: 4,
            border: 'solid 2px white'
          }
        }}>
          <div className={classes.reports}>
            <div data-test="report-parameters" className={classes.parametersArea}>
              <Grid container spacing={2} classes={
                {
                  "spacing-xs-2": this.props.classes.fullGrid
                }
              }>
                {headers.map((p, index) => {
                  return <Grid data-test={"heading-" + index} key={index} item xs={gridWidth} style={{ borderRight: 'solid 1px #e5e5e5' }}>
                    {"description" in p &&
                      <QueryParameterDisplay
                        updateEvent={this.monitorLinkUpdate}
                        key={p.id}
                        id={p.id}
                        graph={graph}
                        defaultLang={defaultLang} />
                    }
                  </Grid>;
                })}
                <Grid item xs={12 - (filters.length * gridWidth)}>
                  <div style={{ textAlign: 'right' }} id="report-reset">
                    <SecondaryButton
                      dataTest="reset-parameters"
                      onClick={this.resetQuery}>Reset</SecondaryButton>
                  </div>
                </Grid>
                {filters
                  .filter(p => componentTypes.includes(p.type))
                  .map(p => {
                    const alias = GS.getAlias(p.type);
                    const label = computeLabelFromType(alias);
                    const components = existingComponents.filter(ec => ec.type === alias).map(ec => ec.id);
                    return <Grid data-test={"component-entry-" + p.variable} key={p.id} item xs={gridWidth} style={{ borderRight: 'solid 1px #e5e5e5' }}>
                      <div style={{ maxWidth: 300 }}>
                        {values[p.variable] ?
                          <ComponentSelector
                            id={project}
                            key="selected"
                            disabled={disabled}
                            defaultLang={defaultLang}
                            includeAll={false}
                            selected={values[p.variable]}
                            components={components}
                            title={label}
                            hintWord={label.toLowerCase()}
                            graph={graph}
                            handleChange={this.handleValueSetting(p.variable)} />
                          :
                          <ComponentSelector
                            id={project}
                            key={keyUuid}
                            disabled={disabled}
                            defaultLang={defaultLang}
                            includeAll={false}
                            components={components}
                            title={label}
                            hintWord={label.toLowerCase()}
                            graph={graph}
                            handleChange={this.handleValueSetting(p.variable)} />
                        }
                      </div>
                    </Grid>;
                  })}
                {filters
                  .filter(p => resourceTypes.includes(p.type))
                  .map(p => {
                    const alias = GS.getAlias(p.type);
                    const label = computeLabelFromType(alias);
                    return <Grid key={p.id} item xs={gridWidth} style={{ borderRight: 'solid 1px #e5e5e5' }}>
                      {values[p.variable] ?
                        <div data-test="parameter-value">
                          <Typography data-test="selected-type" variant="caption" style={{ color: 'black' }}>Selected {label}</Typography>
                          <CommonIriDisplay
                            id={values[p.variable]}
                            compact={true}
                            isReadOnly={false}
                            loadComponents={true}
                            projectIRI={project}
                            handleNotAvailable={true}
                            graph={graph}
                            onDeleteIRI={this.removeValueSetting(p.variable)}
                            viewLang={defaultLang}
                            defaultLang={defaultLang} />
                        </div>
                        :
                        <div
                          data-test={"parameter-search-" + p.variable}
                          style={{ marginTop: 20, height: 40, maxWidth: 300, overflow: 'visible' }}>
                          <ReportSearch
                            graph={graph}
                            componentIRI={p.constraint}
                            key={keyUuid}
                            title={"Find a " + label.toLowerCase()}
                            label={resourceTypesLabel[p.type]}
                            property={resourceTypesProperty[p.type]}
                            existingComponents={existingComponents}
                            searchClass={p.type}
                            inComponent={resourceTypesInComponent[p.type]}
                            onFoundResource={this.handleValueSetting(p.variable)}
                            defaultLang={defaultLang}
                          />
                        </div>
                      }
                    </Grid>;
                  })}
                {filters
                  .filter(p => literalTypes.includes(p.type))
                  .map(p => {
                    const datatypeLimits = DATATYPE_LIMITS[p.type];
                    return <Grid key={p.id} item xs={gridWidth} style={{ borderRight: 'solid 1px #e5e5e5' }}>
                      {p.type === "http://www.w3.org/2001/XMLSchema#date" ?
                        <div style={{ marginTop: values[p.variable] ? 20 : 17 }}>
                          {values[p.variable] ?
                            <DateField
                              isReadOnly={false}
                              date={values[p.variable]}
                              onDelete={this.removeValueSetting(p.variable)}
                              graph={graph} />
                            :
                            <GetDateValueDialog
                              title={"Select Date"}
                              useButton={true}
                              name="Date"
                              onSetDate={this.handleDataChange(p.variable)} />
                          }
                        </div>
                        :
                        <div style={{ marginTop: 12, maxWidth: 300 }} data-test="parameter-value">
                          <TextField
                            name="literal"
                            margin="dense"
                            variant="outlined"
                            autoFocus={false}
                            fullWidth={true}
                            placeholder={"Enter " + (p.type.substring(33) === "integer" ? "an " : "a ") + p.type.substring(33) + " value"}
                            error={literalError[p.variable]}
                            value={values[p.variable] ? values[p.variable] : ""}
                            helperText={
                              literalError[p.variable] && values[p.variable] !== "" ?
                                <span data-test={"helper-text-" + p.variable}>Expecting {p.type.substring(33)} input.</span>
                                :
                                null
                            }
                            onChange={this.handleLiteralChange(p.type, p.variable)}
                            InputProps={{
                              className: classes.inputLabel,
                              inputProps: {
                                "data-test": "literal-input-" + p.variable,
                                maxLength: datatypeLimits && datatypeLimits.maxLength ? datatypeLimits.maxLength : MAX_LITERAL_LENGTH
                              }
                            }} />
                        </div>
                      }
                    </Grid>;
                  })}
                {filters.filter(p => p.type === NS_ACL + "User")
                  .map(p => {
                    return <Grid key={p.id} item xs={gridWidth} style={{ borderRight: 'solid 1px #e5e5e5' }}>
                      <div style={{ maxWidth: 300 }}>
                        {values[p.variable] ?
                          <ProjectUsers
                            label="User"
                            key="selected"
                            selected={values[p.variable]}
                            includeAll={false}
                            projectUsers={projectUsers}
                            hintWord="user"
                            onUserChange={this.handleValueSetting(p.variable)} />
                          :
                          <ProjectUsers
                            label="User"
                            key={keyUuid}
                            selected=""
                            includeAll={false}
                            projectUsers={projectUsers}
                            hintWord="user"
                            onUserChange={this.handleValueSetting(p.variable)} />
                        }
                      </div>
                    </Grid>;
                  })}
                <Grid item xs={12 - (filters.length * gridWidth)}>
                  <div style={{ textAlign: 'right', marginTop: 18 }} id="report-run">
                    <PrimaryButton
                      dataTest="run-parameters"
                      endIcon={<PlayArrowIcon />}
                      disabled={queryRunning || disabled || invalidLiterals || incomplete}
                      onClick={this.playQuery}>{
                        queryRunning ?
                          "..."
                          :
                          "Run"
                      }</PrimaryButton>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
          {isErrored && <Errored data={{ message: errorMessage }} clearError={this.clearError} />}
        </div>
      </div>
    );
  }
}

ReportParameters.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  existingComponents: PropTypes.array,
  queryRunning: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultLang: PropTypes.string.isRequired,
  playQuery: PropTypes.number,
  project: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  projectType: PropTypes.string.isRequired,
  projectUsers: PropTypes.array,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(ReportParameters));
